// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1IgLz","head":"ProcedureTableInfo_head__3faiu"};